import Modal from "../../Helpers/UI/Modal";

export default class ChangeSizeModal extends Modal {
    constructor(modalName) {
        super(modalName);
        this.sizeOptions = [];
        LUC.Modals[modalName] = this;
    }

    renderSizeOptions(sizeOptions) {
        this.sizeOptions = sizeOptions;
    }
}
